// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1KrdL","label":"Completed_label__3Ah9X"};